<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
  <div class="card">
    <div class="card-header">
      <div class="row g-2 align-items-center">
        <div class="col-12 col-md-6">
          <h5 class="card-title mb-0">{{ 'weeklySchedule' | translate }}</h5>
          <h6 class="card-subtitle text-muted mt-1">{{ 'adjustWeeklySchedule' | translate }}</h6>
        </div>

        <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
          <div class="btn-group btn-group-sm" role="group" [attr.aria-label]="'viewMode' | translate">
            <button type="button" class="btn" (click)="viewMode = 'programs'"
              [ngClass]="viewMode === 'programs' ? 'btn-secondary' : 'btn-outline-secondary'">
              {{ 'programs' | translate }}
            </button>
            <button type="button" class="btn" (click)="viewMode = 'periods'"
              [ngClass]="viewMode === 'periods' ? 'btn-secondary' : 'btn-outline-secondary'">
              {{ 'periods' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body d-flex align-items-center justify-content-center py-5" *ngIf="loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'loading' | translate }}</span>
      </div>
    </div>

    <div class="card-body" *ngIf="!loading">
      <app-lum-scheduler-programs
        *ngIf="viewMode === 'programs'"
        [device]="device"
        [schedulerData]="schedulerData"
        [astcalData]="astcalData"
        (schedulesChanged)="onSchedulesChanged()">
      </app-lum-scheduler-programs>

      <app-lum-scheduler-periods
        *ngIf="viewMode === 'periods'"
        [device]="device"
        [schedulerData]="schedulerData"
        (periodsChanged)="onPeriodsChanged()">
      </app-lum-scheduler-periods>
    </div>
  </div>
</div>
